// ===== CONFIGURATIONS =====
export const OPLITUDE_ACCESS_URL =
  "https://oplitude.starsaceleradora.com.br/acesso/entrar";
